import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import ProtectedRoute from './protectedRoutes';
import { history } from '../Redux/Store';

import AuthPage from '../Components/Login';
import Dashboard from '../Components/Dashboard';
import FormMapping from '../Components/Mapping';
import CreateFrom from '../Components/CreateForm';
import PreviewForm from '../Components/PreviewForm';
import EditPreviewForm from '../Components/EditPreviewForm';
import EditForm from '../Components/EditForm';
import Submitted from '../Components/Submitted';
import DocumentVault from '../Components/DocumentVault';
import UserDocuments from '../Components/DocumentVault/userDocument';
import FormListing from '../Components/FormBuilder';
import PaymentCompleted from '../Components/Payment';
import Warning from '../Components/Ui/400';

const Routes = () => (
    <BrowserRouter>
        <Switch history={history}>
            <Route exact path="/" component={AuthPage} />
            <Route exact path="/forgot-password" component={AuthPage} />
            <ProtectedRoute exact path="/dashboard" loggedUser={true} component={Dashboard} />
            <ProtectedRoute exact path="/form-builder" loggedUser={true} component={FormListing} />
            <ProtectedRoute exact path="/create-form" loggedUser={true} component={CreateFrom} />
            <ProtectedRoute exact path="/preview-form/:formID" loggedUser={true} component={PreviewForm} />
            <ProtectedRoute exact path="/update-job/:jobID" loggedUser={true} component={EditPreviewForm} />
            <ProtectedRoute exact path="/edit-form/:formID" loggedUser={true} component={EditForm} />
            <ProtectedRoute exact path="/submitted-form/:formID" loggedUser={true} component={Submitted} />
            <ProtectedRoute exact path="/form-mapping" loggedUser={true} component={FormMapping} />
            <ProtectedRoute exact path="/document-vault" loggedUser={true} component={DocumentVault} />
            <ProtectedRoute exact path="/document-vault/:userID" loggedUser={true} component={UserDocuments} />
            <ProtectedRoute exact path="/payment/completed" loggedUser={true} component={PaymentCompleted} />
            <Route component={Warning} />
        </Switch>
    </BrowserRouter>
);

export default Routes;